import Vue from 'vue'
import gql from 'graphql-tag'
import { Component, Emit, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Account } from '@/modules/Account/interfaces/account'

import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import AccountsList from '@/modules/Account/scripts/accounts-list'
import { getAccounts } from '@/modules/Account/gql/account.gql'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import OpenCasesDialog from '../components/OpenCasesDialog.vue'

@Component({
  components: {
    OpenCasesDialog
  }
})
export default class AccountsWithCases extends AccountsList {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Client Information'
    },
    {
      text: 'Accounts with Open Case'
    }
  ]

  withOpenCase = true

  casesDialog = {
    show: false,
    title: 'Open Cases',
    accountId: -1
  }

  showOpenCases (accountId: number) {
    this.casesDialog.accountId = +accountId
    this.casesDialog.show = true
  }

  onDialogClose () {
    this.casesDialog.accountId = -1
    this.casesDialog.show = false
  }

  @Watch('accounts')
  onAccountsLoaded (val: Account[]) {
    if (val.length > 0) {
      this.tableLoading = false
    }
  }

  routeToDetail (item: any, subPage = 'Detail') {
    return {
      name: `AccountDetail${subPage}`,
      params: {
        id: item.id
      }
    }
  }

  routeToSource (id: string) {
    this.$router.push({
      name: 'ProducerDetail',
      params: {
        id
      }
    })
  }

  async getAccounts () {
    const { searchVal, options, defaultSort } = this
    const { sortBy, sortDesc, tablePage } = options
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || defaultSort
    const filter: {
      [key: string]: any;
    } = {}
    if (searchVal) {
      filter.name = searchVal
      filter.phone = searchVal
    }

    filter.withOpenCase = true

    this.tableLoading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAccounts,
        variables: {
          filter,
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.accounts = result.data.getAccounts.accounts
      this.tableLoading = false
      this.options.tablePage.total = result.data.getAccounts.paging.totalCount
      this.storePage()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
